<template>
  <div class="adminHome">
    <device-nav :deviceList="deviceList"></device-nav>
    <component :is="shownComponent" v-if="shownComponent" class="article"></component>
  </div>
</template>
<script>
import deviceNav from './sidebar'
import deviceOverview from './overview'
import deviceDetail from './detail'
import { mapGetters } from 'vuex'
export default {
  components: {
    deviceNav,
    deviceOverview,
    deviceDetail,
  },
  data() {
    return {
      shownComponent: null, // overview: 设备列表; detail: 设备详情
      deviceList: [], // 设备列表
    }
  },
  computed: {
    ...mapGetters({
      deviceInfo: 'getDeviceInfo'
    }),
  },
  watch: {
    deviceInfo: {
      handler (val) {
        if(val.sn) {
          this.shownComponent = 'deviceDetail'
        } else {
          this.shownComponent = 'deviceOverview'
        }
      },
      deep: true
    },
    // 响应更新电站列表事件
    '$store.state.event.updateDeviceList'(val) {
      if(val) {
        this.queryDeviceList(true)
        this.$store.state.event.updateDeviceList = false
      }
    }
  },
  created() {
    this.queryDeviceList()
  },
  beforeDestroy() {
    this.$store.commit('saveDeviceInfo', {
      sn: null
    })
  },
  methods: {
    // 查询用户设备列表
    queryDeviceList (noRefresh) {
      let param = {
        devtype: 2304,
        pagesize: 500
      }
      this.$request.get('webQueryDeviceEs', param).then(res => {
        if(res.err === 0) {
          this.deviceList = res.dat.device

          let devcode = this.$route.query.devcode, pn = this.$route.query.pn, devaddr = this.$route.query.devaddr, sn = this.$route.query.sn
          let selectedDevice = this.deviceList.find(item => {
              return item.devcode == devcode && item.pn == pn && item.devaddr == devaddr && item.sn == sn
            })
          if (!noRefresh) {
            if (sn && selectedDevice) {
              this.$store.commit('saveDeviceInfo', selectedDevice)
              return
            } else if (this.deviceList.length) {
              this.$store.commit('saveDeviceInfo', this.deviceList[0])
              return
            }
          }
        }
        this.$store.commit('saveDeviceInfo', {pn:'',sn:'',devcode:'',devaddr:''})
      })
    }
  }
}
</script>
<style lang="less" scoped>
.adminHome {
  flex: 1;
  display: flex;
  align-items: stretch;
  background: #f0f0f0;
  .article {
    display: flex;
    flex: 1;
    overflow: hidden;
  }
}
</style>
